import * as React from 'react';

interface SpaceProps {
  num?: number;
}

export const Space: React.FC<SpaceProps> = ({ num = 1 }) => {
  return <div style={{ height: `${8 * num}px`, width: `${8 * num}px` }} />;
};
